import { getLocale } from '@/helpers/locale-helper';

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DEFAULT_API_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DEFAULT_DATE_FORMAT_NO_SEC = 'DD/MM/YYYY HH:mm';
export const SHORT_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_DX_DATE_FORMAT = 'dd/MM/yyyy HH:mm:ss';
export const SHORT_DX_DATE_FORMAT = 'dd/MM/yyyy';
export const TIME_REGEX = /^(2[0-3]|[0-1][0-9]):([0-5][0-9]):([0-5][0-9])$/;
export const DATE_PICKER_DATE_REGEX = /^\d\d\/\d\d\/\d\d\d\d$/;

export class DxDataGridLocalizationDefaults {
  filterBuilderOperationDescriptions = {
    between: getLocale('documentsview.gridLocale.filter-builder.between'),
    contains: getLocale('documentsview.gridLocale.filter-builder.contains'),
    endsWith: getLocale('documentsview.gridLocale.filter-builder.endsWith'),
    equal: getLocale('documentsview.gridLocale.filter-builder.equal'),
    greaterThan: getLocale('documentsview.gridLocale.filter-builder.greaterThan'),
    greaterThanOrEqual: getLocale('documentsview.gridLocale.filter-builder.greaterThanOrEqual'),
    isBlank: getLocale('documentsview.gridLocale.filter-builder.isBlank'),
    isNotBlank: getLocale('documentsview.gridLocale.filter-builder.isNotBlank'),
    lessThan: getLocale('documentsview.gridLocale.filter-builder.lessThan'),
    lessThanOrEqual: getLocale('documentsview.gridLocale.filter-builder.lessThanOrEqual'),
    notContains: getLocale('documentsview.gridLocale.filter-builder.notContains'),
    notEqual: getLocale('documentsview.gridLocale.filter-builder.notEqual'),
    startsWith: getLocale('documentsview.gridLocale.filter-builder.startsWith')
  };

  filterBuilderGroupOperationDescriptions = {
    and: getLocale('documentsview.gridLocale.filter-builder.and'),
    notAnd: getLocale('documentsview.gridLocale.filter-builder.notAnd'),
    notOr: getLocale('documentsview.gridLocale.filter-builder.notOr'),
    or: getLocale('documentsview.gridLocale.filter-builder.or')
  };

  filterPanelTexts = {
    clearFilter: getLocale('documentsview.gridLocale.filter-panel.clearFilter'),
    createFilter: getLocale('documentsview.gridLocale.filter-panel.createFilter'),
    filterEnabledHint: getLocale('documentsview.gridLocale.filter-panel.filterEnabledHint')
  };
  filterRow = {
    applyFilterText: getLocale('documentsview.gridLocale.filter-row.applyFilterText'),
    betweenEndText: getLocale('documentsview.gridLocale.filter-row.betweenEndText'),
    betweenStartText: getLocale('documentsview.gridLocale.filter-row.betweenStartText'),
    resetOperationText: getLocale('documentsview.gridLocale.filter-row.resetOperationText'),
    operationDescriptions: {
      between: getLocale('documentsview.gridLocale.filter-row.between'),
      contains: getLocale('documentsview.gridLocale.filter-row.contains'),
      endsWith: getLocale('documentsview.gridLocale.filter-row.endsWith'),
      equal: getLocale('documentsview.gridLocale.filter-row.equal'),
      greaterThan: getLocale('documentsview.gridLocale.filter-row.greaterThan'),
      greaterThanOrEqual: getLocale('documentsview.gridLocale.filter-row.greaterThanOrEqual'),
      lessThan: getLocale('documentsview.gridLocale.filter-row.lessThan'),
      lessThanOrEqual: getLocale('documentsview.gridLocale.filter-row.lessThanOrEqual'),
      notContains: getLocale('documentsview.gridLocale.filter-row.notContains'),
      notEqual: getLocale('documentsview.gridLocale.filter-row.notEqual'),
      startsWith: getLocale('documentsview.gridLocale.filter-row.startsWith')
    }
  };
};

export const USER_UI_EVENTS_TO_LISTEN_TO_PROCESS_IDLE = [
  'click',
  'contextmenu',
  'keydown',
  'mousemove',
  'scroll',
  'touchstart'
];
